import type { Contract } from '../services/contractApi';
import type { ContractTemplateSummary } from '../components/contracts/ContractRentalDocumentBody';
import { formatContractPaymentSchedule } from './contractPaymentSchedule';
import { formatContractDisplayDate, formatContractLegalDate } from './contractTenantInfo';
import { formatContractMoneyVnd } from './propertyDeposit';

export function summaryFromContract(detail: Contract): ContractTemplateSummary {
  const frozen = detail.template_document;
  if (frozen && typeof frozen === 'object') {
    return {
      ...frozen,
      paymentSchedule: formatContractPaymentSchedule(
        frozen.rentPaymentDay ?? detail.rent_payment_day,
        frozen.paymentSchedule,
      ),
    };
  }

  const monthly = detail.monthly_payment ?? detail.amount;
  return {
    number: `CT-${String(detail.id).padStart(6, '0')}`,
    date: formatContractLegalDate(detail.created_at) || formatContractDisplayDate(detail.created_at),
    location: detail.full_address || 'Cộng đồng KN',
    ownerName: detail.landlord_name || 'Chủ nhà',
    tenantName: detail.tenant_name || 'Người thuê',
    tenantId: detail.tenant_cccd,
    tenantAddress: detail.tenant_address,
    tenantPhone: detail.tenant_phone,
    propertyAddress: detail.full_address,
    unitName: detail.room_number,
    startDate: formatContractDisplayDate(detail.start_date) || detail.start_date,
    endDate: formatContractDisplayDate(detail.end_date) || detail.end_date,
    rent: monthly ? formatContractMoneyVnd(Number(monthly)) : '',
    deposit: detail.deposit ? formatContractMoneyVnd(Number(detail.deposit)) : '',
    rentPaymentDay: detail.rent_payment_day,
    paymentSchedule: formatContractPaymentSchedule(detail.rent_payment_day),
    contractEffectiveDate: formatContractLegalDate(detail.start_date),
  };
}
